module.exports = __webpack_public_path__ + "img/双重.e12643b1.png";